import React, { Component } from 'react'
import Hero from '../components/hero/hero'
import AboutUs from '../components/aboutus/aboutus'
import Plans from '../components/plans/plans'
import MVV from '../components/mvv/mvv'
import Team from '../components/team/team'
import Contact from '../components/contact/contact'
import CTA from '../components/cta/cta'

class HomePage extends Component {
    render() {
        return(
            <div>
                <Hero/>
                <AboutUs  colored={false}  dark={false}/>
                <Plans    colored={true}   dark={false}/>
                <Team     colored={false}  dark={false}/>
                <MVV      colored={true}   dark={false}/>
                <CTA/>
                <Contact  colored={false}  dark={false}/>
            </div>
        )
    }
}

export default HomePage